var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecycleBinRestoreHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.111,
    height: 44,
    viewBox: "0 0 39.111 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "restore_from_trash_24dp_FILL1_wght400_GRAD0_opsz24",
    d: "M177.111-808.222H182v-10.145l3.911,3.789L189.333-818l-9.778-9.778L169.778-818l3.422,3.422,3.911-3.789ZM167.333-796a4.708,4.708,0,0,1-3.453-1.436,4.708,4.708,0,0,1-1.436-3.453v-31.778H160v-4.889h12.222V-840h14.667v2.444h12.222v4.889h-2.444v31.778a4.708,4.708,0,0,1-1.436,3.453A4.708,4.708,0,0,1,191.778-796Z",
    transform: "translate(-160 840)",
    fill: "#22638d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleBinRestoreHeader);
export default __webpack_public_path__ + "static/media/recycleBinRestoreHeader.9a13e622928d363dd9cd8aac924804ba.svg";
export { ForwardRef as ReactComponent };